import { marginSize } from '../../Utilities/utils/Theming';

const barLargeStyle = () => {
	return {
		height: 'var(--epods--progressbar-size-large-height)',
	};
};

const barSmallStyle = () => {
	return {
		height: 'var(--epods--progressbar-size-small-height)',
	};
};

export const barStyle = (props: any) => {
	let sizeBar = barSmallStyle();
	if (props.size === 'large') {
		sizeBar = barLargeStyle();
	}
	return {
		backgroundColor: 'var(--epods--progressbar-trackbar-bg)',
		...sizeBar,
	};
};

export const barContainerStyle = () => {
	return {
		...marginSize('0', '0', 'var(--epods--progressbar-margin-bottom)', '0'),
	};
};

export const barLabelStyle = () => {
	return {
		fontFamily: 'var(--epods--font-base)',
		fontSize: 'var(--epods--progressbar-label-size)',
		lineHeight: 'var(--epods--progressbar-label-height)',
		color: 'var(--epods--progressbar-label-color)',
	};
};

export const barProgressLargeStyle = (value: any, showLabel: boolean | undefined) => {
	return {
		color: 'var(--epods--progressbar-large-label-color)',
		position: 'relative',
		':after': {
			fontFamily: 'var(--epods--font-base)',
			fontSize: 'var(--epods--progressbar-label-size)',
			position: 'absolute',
			content: showLabel && value > 5 ? `"${value}%"` : '',
			right: '9px',
			lineHeight: 'var(--epods--progressbar-size-large-height)',
		},
	};
};
